import api from '../services/api';
import { stringToHTML } from '../utils/to-html';
import { checkQuantity } from '../components/update-cart';
import { $Q, $Qll } from './query-selector';

/**
 * Set quantity
 * Set item quantity with custom input,
 * Execute updateCart function
 * @author Cristian Velasco
 */
export const setQuantity = () => {
  return $Qll('.quantity-label').forEach((labelParent) =>
    $Qll('button', labelParent).forEach((btn) => {
      btn.addEventListener('click', updateQuantity);
    })
  );
};

/**
 * Add or subtract input value
 * Ensures the value does not exceed maximum quantity
 * @author Cristian Velasco
 */
function updateQuantity() {
  let input = $Q('input', this.parentElement);
  let variantPrice = $Q('#variantPrice');
  let inputValue = input.getAttribute('min') ? input.getAttribute('min') : 0;
  let pricesToUpdate = $Qll('[data-variant-price]');

  if (this.dataset.action === 'subtr') {
    if (input.value > inputValue) {
      input.value--;
    }
  } else {
    const isOutOfStock = checkQuantity(input);

    // Stop increment if the maximum quantity is reached
    if (isOutOfStock) return;

    const maxQuantity = input.getAttribute('max');
    if (maxQuantity && parseInt(input.value) >= parseInt(maxQuantity)) {
      return; // Prevent increasing beyond the max quantity
    }

    input.value++;
  }

  if (variantPrice) {

    let variantPriceVal = input.value * variantPrice.value;

    if (input.closest('.jc-main-product-quantity')) {
      pricesToUpdate.forEach((priceElem) => {
        priceElem.innerHTML =
          variantPriceVal.toFixed(2) + '€ ' + variantPrice.dataset.currencyHt;
      });
    }
  }

  // Trigger a change event to notify listeners
  return input.dispatchEvent(new Event('change'));
}

export const renderQuantityLimit = async (variant) => {
  const productDetail = $Q('#main-product__detail');
  const activeVariant = $Q(`[id="${variant}"]`, productDetail);

  if (!productDetail || !activeVariant) return;

  const product_url = productDetail.dataset.url;
  const params = {
    variant,
    sections: 'ajax-main-product,sticky-cart',
  };

  const response = await api.shopifySectionByUrlAndParams(product_url, params);
  const sectionHTML = stringToHTML(response['ajax-main-product']);
  const stickyHTML = stringToHTML(response['sticky-cart']);

  const updatedB2BbLimit = sectionHTML.querySelector('.jc-main-product-b2b-limit');
  const updatedVariantQuantity = sectionHTML.querySelector('.variant-quantity');
  const updatedPrice = sectionHTML.querySelector('.jc-main-product-price');
  const updatedStickyAddToCart = stickyHTML.querySelector('.sticky-btn-add-to-cart');

  const B2BLimit = $Q('.jc-main-product-b2b-limit');
  const variantQuantity = $Q('.variant-quantity');
  const price = $Q('.jc-main-product-price');
  const stickyAddToCart = $Q('.sticky-btn-add-to-cart');

  const B2BLimitParent = B2BLimit.parentElement;
  const addToCart = B2BLimitParent.querySelector('.btn-add-to-cart');
  const updatedAddToCart = updatedB2BbLimit.parentElement.querySelector('.btn-add-to-cart');

  // Update limit liquid
  B2BLimit.outerHTML = updatedB2BbLimit.outerHTML;

  // Update variant quantity
  variantQuantity.outerHTML = updatedVariantQuantity.outerHTML;

  // Update add to cart buttons
  addToCart.outerHTML = updatedAddToCart.outerHTML;
  stickyAddToCart.innerHTML = updatedStickyAddToCart.innerHTML;
  stickyAddToCart.disabled = updatedStickyAddToCart.disabled;

  //Update price container
  price.outerHTML = updatedPrice.outerHTML;
}
